import Swiper from "swiper/bundle"
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class HeroSlider {
  constructor() {
    const progressCircle = document.querySelector(".autoplay-progress svg");
    const progressContent = document.querySelector(".autoplay-progress span");

    const swiper = new Swiper('.swiper-hero', {
      modules: [Navigation, Pagination],
      allowTouchMove:false,
      observer: true, 
      observeParents: true,
      spaceBetween: 0,
      centeredSlides: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: true
      }
      
    });

    const swiperPartners = new Swiper('.swiper-partners', {
      modules: [Navigation, Pagination],
      allowTouchMove:true,
      spaceBetween: 20,
      centeredSlides: false,
      autoplay: true,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-partners-button-next",
        prevEl: ".swiper-partners-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });

    const swiperActivities = new Swiper('.swiper-activities', {
      modules: [Navigation, Pagination],
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:4,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-activity-button-next",
        prevEl: ".swiper-activity-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });

    if(ootlahData.page=="single-package"){

      const swiperActivity = new Swiper('.swiper-single-package', {
        modules: [Navigation, Pagination],
        allowTouchMove:true,
        spaceBetween: 0,
        centeredSlides: false,
        slidesPerView:1,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-single-button-next",
          prevEl: ".swiper-single-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          250: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 0,
          }
        }
      });

      const swiperRelatedActivities = new Swiper('.swiper-related-activities', {
        modules: [Navigation, Pagination],
        allowTouchMove:true,
        spaceBetween: 30,
        centeredSlides: false,
        slidesPerView:4,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-related-activity-button-next",
          prevEl: ".swiper-related-activity-button-prev",
        },
        breakpoints: {
          250: {
            slidesPerView: 1.1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1.2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }
      });
    }

    const swiperAdventures = new Swiper('.swiper-adventures', {
      modules: [Navigation, Pagination],
      lazy: {
        loadPrevNext: true, // Preloads next and previous slides
        loadPrevNextAmount: 2, // Number of slides to preload
      },
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:6,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-adventure-button-next",
        prevEl: ".swiper-adventure-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 20,
        },
      }
    });

    const swiperAdventuresListing = new Swiper('.swiper-adventures-listing', {
      modules: [Navigation, Pagination],
      lazy: true,
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:6,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-adventure-button-next",
        prevEl: ".swiper-adventure-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        250: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 1.6,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      }
    });

    const swiperDestiantions = new Swiper('.swiper-destinations', {
      modules: [Navigation, Pagination],
      lazy: true,
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:3,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-destinations-button-next",
        prevEl: ".swiper-destinations-button-prev",
      },
      // pagination: {
      //   el: ".swiper-pagination",
      // },
      breakpoints: {
        250: {
          slidesPerView: 1.5,
          spaceBetween: 20
          
        },
        640: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 20,
          
          
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20
          
        },
      }
    });

    const swiperCities = new Swiper('.swiper-cities', {
      modules: [Navigation, Pagination],
      lazy: true,
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:3,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-cities-button-next",
        prevEl: ".swiper-cities-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20
          
        },
      }
    });

    const swiperCitiesListing = new Swiper('.swiper-cities-listing', {
      modules: [Navigation, Pagination],
      lazy: true,
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:3,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-cities-button-next",
        prevEl: ".swiper-cities-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 20
          
        },
      }
    });

    const swiperReviews = new Swiper('.swiper-reviews', {
      modules: [Navigation, Pagination],
      allowTouchMove:true,
      spaceBetween: 30,
      centeredSlides: false,
      slidesPerView:3,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-reviews-button-next",
        prevEl: ".swiper-reviews-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }
    });

    const swiperMustTry = new Swiper('.swiper-must-try', {
      modules: [Navigation, Pagination],
      allowTouchMove:true,
      centeredSlides: false,
      slidesPerView:'auto',
      autoplay: false,
      navigation: {
        nextEl: ".swiper-must-try-button-next",
        prevEl: ".swiper-must-try-button-prev",
      },
      breakpoints: {
        250: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        1024: {
         
          spaceBetween: 10,
        },
      }
    });

  }
}

export default HeroSlider
